import React from 'react';

import classNames from 'classnames';
import classes from './TextTruncate.module.scss';

type TextTruncateProps = {
  text: string;
  className?: string;
};

const TextTruncate = ({ text, className }: TextTruncateProps) => {
  const boxClasses = classNames(className, classes.slice);

  return <p className={boxClasses}>{text}</p>;
};

export { TextTruncate };
